import { ChangeDetectionStrategy, Component, HostListener, inject, signal, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppRoutes } from '@core';
import { SzIconComponent } from '../../display/sz-icon';

/**
 * Menu modułów w top-barze: trigger (ikona siatki) + panel wysuwany od góry.
 * Amunicja nawiguje do modułu; Zawody i Kalkulator HF to zapowiedzi (wyszarzone, bez akcji).
 */
@Component({
  selector: 'sz-modules-menu',
  templateUrl: './sz-modules-menu.component.html',
  styleUrls: ['./sz-modules-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, SzIconComponent]
})
export class SzModulesMenuComponent {
  private readonly router: Router = inject(Router);

  readonly open: WritableSignal<boolean> = signal<boolean>(false);

  toggle(): void {
    this.open.update((value: boolean): boolean => !value);
  }

  close(): void {
    this.open.set(false);
  }

  goAmmo(): void {
    this.close();
    void this.router.navigate([AppRoutes.AMMO]);
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.close();
  }
}
